import { render, staticRenderFns } from "./GeneticSimilaritiesTopHeader.vue?vue&type=template&id=53f650d0&scoped=true"
import script from "./GeneticSimilaritiesTopHeader.vue?vue&type=script&lang=js"
export * from "./GeneticSimilaritiesTopHeader.vue?vue&type=script&lang=js"
import style0 from "./GeneticSimilaritiesTopHeader.vue?vue&type=style&index=0&id=53f650d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f650d0",
  null
  
)

export default component.exports